import { render, staticRenderFns } from "./ConnectSAML.vue?vue&type=template&id=3c0ff967&scoped=true&"
import script from "./ConnectSAML.vue?vue&type=script&lang=js&"
export * from "./ConnectSAML.vue?vue&type=script&lang=js&"
import style0 from "./ConnectSAML.vue?vue&type=style&index=0&id=3c0ff967&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c0ff967",
  null
  
)

export default component.exports